module.exports = __webpack_public_path__ + "img/mercado-ver-o-peso.559040bb.jpg";